/**
 * Configuration du netting par fournisseur.
 *
 * Clé : integration_technical_name du provider
 *
 * Modes disponibles : 'file_upload', 'ftps', 'api'
 *
 * - pro : mode de process pour le bloc PRO (null = pas de bloc PRO)
 *
 * Le bloc Particuliers est toujours présent et utilise le netting_process_type du backend.
 */
const NETTING_CONFIG = {
  totalenergies: {
    pro: 'file_upload',
  },
}

/**
 * Récupère la config PRO d'un fournisseur.
 *
 * @param {string|null|undefined} technicalName - integration_technical_name du provider
 * @returns {{ pro: string|null }}
 */
export const getNettingConfig = (technicalName) => {
  if (technicalName && NETTING_CONFIG[technicalName]) {
    return NETTING_CONFIG[technicalName]
  }
  return { pro: null }
}

/**
 * Vérifie si un fournisseur supporte le netting PRO.
 * @param {string|null|undefined} technicalName - integration_technical_name du provider
 * @returns {boolean}
 */
export const hasProNetting = (technicalName) => {
  const config = technicalName && NETTING_CONFIG[technicalName]
  return Boolean(config?.pro)
}
